import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import {CommonService} from '../../_services/common.services';
import { CellClickedEvent, ColDef, SideBarDef } from 'ag-grid-community';
import { Observable } from 'rxjs';
import 'ag-grid-enterprise';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {CompanySharedService} from '../../_services/company-shared.service';
import { BaseRequestService } from 'src/app/_services/base.service';
import { MyToastrService } from 'src/app/_services/toastr.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-gl-aggrid',
  templateUrl: './gl-aggrid.component.html',
  styleUrls: ['./gl-aggrid.component.scss']
})
export class GlAggridComponent implements OnInit {

  @Output() selectionChange = new EventEmitter();
  @Output() refreshCallback = new EventEmitter();
  public selectedRow: any = [];
  private gridApi: any;
  public columnTypes: any;
  public defaultColDef: any;
  public columnDefs: ColDef[] = [];
  public statusBar: any;
  public api: any;
  public columnApi: any; 
  // public gridOptions: any;
  // sideBar: any;
  autoGroupColumnDef: any;
  public rowGroupPanelShow: any;
  public gridColumnApi: any;
  // @Input() columnData = [];
  @Input() columnGlData = [];
  // @Input() rowsData = [];
  @Input() rowGlData = [];
  rowData: any = [];
  sourceColumnName: any = '';
  searchRec: any = '';
  currentRecon: any;
  remarksData: any = [];
  checked: boolean = false;
  currentReconProcess: any;
  reportBuilder: any;
  allColumns: any;
  rowGroup: any;
  gridOptions: any;
  filteredRowCount: number = 0;
  filteredRowdata: Array<any> = [];
  gridTableSetting: any = [];
  gridTable: any = [];
  currentUser: any;
  glview: boolean = true;
  glcountview: boolean = true;
  sideBar: SideBarDef | string | string[] | boolean | null;
  isLocked: boolean = false;
  // reconview: boolean = true;
  constructor(private authService: AuthenticationService, private http: HttpClient, public cs: CompanySharedService, public commonService: CommonService,
    private chageDetect: ChangeDetectorRef, private baseService: BaseRequestService, private toast: MyToastrService) {
      this.currentReconProcess = this.commonService.currentReconProcess;
      this.sourceColumnName = this.commonService.sourceColumnName;
      this.reportBuilder = this.commonService.customReport ? this.commonService.customReport : false;
      this.currentUser = this.authService.currentUser;
      // let glname: any = this.commonService.glreconName;
      // let glcountrecords: any = this.commonService.glCountRecords;
      // if (typeof glname === 'object' || glname === undefined || glname === '') { // || typeof glcountrecords === 'object' || glcountrecords === undefined || glcountrecords === ''
      //   this.reconview = true;
      //   this.glcountview = false;
      //   this.glview = false;
      // } else if(typeof glname === 'string' || glname !== undefined || glname !== '') { // if(glcountrecords === 'glcountData' || glname !== '')
      //   this.reconview = false;
      //   this.glview = true;
      //   this.glcountview = false;
      // } else if((typeof glname === 'string' || glname !== undefined || glname !== '') && (glcountrecords === 'glcountData')) {
      //   this.reconview = false;
      //   this.glview = true;
      //   this.glcountview = true;
      // }
    // console.log("sourceColumn",);
    // || ele.field === 'Recon Remarks' filter: 'agSetColumnFilter'
    setTimeout(() => {
      if(this.sourceColumnName === "authwaiting" || this.sourceColumnName === "rollbackwaiting") {
        this.columnGlData.forEach((obj: any) => {
          if(obj.field === 'LINK_ID') {
            Object.assign(obj, {rowGroup: true, enableRowGroup: true, enableValue: true, enablePivot: true});
          } 
          else if(obj.field !== 'LINK_ID') {
            Object.assign(obj, {});
            // enableRowGroup: true, enableValue: true, enablePivot: true
          }
        })
      }
      this.columnGlData.forEach((ele: any) => {
        if(ele.field === 'STATEMENT_DATE') {
          Object.assign(ele, {filter: 'agDateColumnFilter', type: ['dateColumn']})
        } else {
          Object.assign(ele, {filter: 'agSetColumnFilter'})
        }
      })
    });
    this.gridOptions = {
      // PROPERTIES
      // Objects like myRowData and myColDefs would be created in your application
      pagination: true,
      rowSelection: "multiple",
      pivotPanelShow: false,
      onGridReady: (event: any) => console.log(event,'The grid is now ready'),
      // EVENTS
      // Add event handlers
      // CALLBACKS
    }
    this.rowGroupPanelShow = 'always';
    this.autoGroupColumnDef = { minWidth: 100 };
    
    this.defaultColDef = {
      minWidth: 100,
      editable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: false,
      resizable: true,
      sortable: true,
      enableRowGroup: true
    };
    console.log("this.columndata", this.columnGlData);
    this.sideBar = 'columns';
    this.columnTypes = {
      numberColumn: {
        width: 100,
        filter: 'agNumberColumnFilter',
      },
      nonEditableColumn: { editable: false },
    };
    this.statusBar = {
      statusPanels: [
        {
          statusPanel: 'agTotalAndFilteredRowCountComponent',
          align: 'left',
        }
      ],
    };
  }
  onGridReady(params: any, value: any) {
    this.sourceColumnName = this.commonService.sourceColumnName;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    let gl: any = 'glcountData';
    if(this.commonService.glCountRecords === gl) {
      this.columnDefs = this.columnGlData;
    }
    if(this.commonService.glreconName) {
      // this.columnDefs = this.columnData;
    }
    // if(value === 'glcount') {
      setTimeout(() => { this.gridApi.setRowData(this.rowGlData) });
      // console.log(this.rowGlData);
    // }
    // if(value === 'glview') {
      // setTimeout(() => { this.gridApi.setRowData(this.rowsData) });
      // console.log(this.rowGlData);
    // }
    this.gridApi.closeToolPanel();
    const columnsToolPanel = this.gridApi.getToolPanelInstance('columns');
    columnsToolPanel.setRowGroupsSectionVisible(false);
    columnsToolPanel.setValuesSectionVisible(false);
    let gridWidth: any = 50;
    // this.columnApi.sizeColumnsToFit(gridWidth);
    params.api.resetRowHeights();
    this.getAggridTableSetting();
    // console.log("this.columnData", this.columnData);
    console.log("this,columnGlData", this.columnGlData);
  }
  ngOnInit() {
    this.chageDetect.detectChanges();
  }
  onSelectionChanged(event?: any) {
    // if(this.filteredRowdata.length > 0) {
    //   this.selectionChange.emit(this.filteredRowdata);
    //   this.selectedRow = this.filteredRowdata;
    //   console.log("all filtered row", this.selectedRow);
    // } else if(this.filteredRowdata.length === 0) {
      this.selectionChange.emit(this.gridApi.getSelectedRows());
      this.selectedRow = this.gridApi.getSelectedRows();
      console.log("only selected row", this.selectedRow);
      this.selectedRow.map((x: any) => { 
        if(x && x.onHold === 'true') {
          this.isLocked = false;
          this.toast.sToast('warning', "Please select either 'OnHold' or 'UnHold' records");
        } else if(x.onHold !== 'true' || x.onHold !== 'false') {
          this.isLocked = true;
        } else {
          this.isLocked = true;
        }
      });
    // }
    // console.log(event);
    // this.selectionChange.emit(this.gridApi.getSelectedRows());
    // this.selectedRow = this.gridApi.getSelectedRows();
    // console.log(this.selectedRow);
  }
  onFilterChanged(event: any) {
    console.log("filter change", event);
    this.filteredRowCount = this.gridOptions.api.getDisplayedRowCount();
    this.filteredRowdata = [];
    this.gridApi.forEachNodeAfterFilter((node: any) => {
      this.filteredRowdata.push(node.data);
    });
  }
  applyFilter() {
    if (this.gridApi) {
       this.gridApi.setQuickFilter(this.searchRec);
    }
  }
  refreshTable() {
    this.refreshCallback.emit();
  }
  clearSelectedRecords() {
    this.searchRec = null || "";
    this.applyFilter();
  }
  downloadSelectedRecords(type: string) {
    this.sourceColumnName = this.commonService.sourceColumnName;
    let fileName: any;
    if(this.commonService && this.commonService.glreconName) {
      fileName = this.commonService.glreconName;
    } else {
      fileName = this.currentReconProcess.reconName+'_'+this.sourceColumnName;
    }
    if(this.selectedRow && this.selectedRow.length > 0) {
      if(type === 'excel') {
        this.gridApi.exportDataAsExcel({
          onlySelected: this.checked,
          fileName: fileName
        });
      } else if(type === 'csv') {
        this.gridApi.exportDataAsCsv({
          onlySelected: this.checked,
          fileName: fileName
        });
      }
    } else {
      this.toast.sToast('info', 'Please Select a recon');
    }
  }
  downloadFromAgGrid(type: string) {
    // let fileName = this.currentReconProcess.reconName+'_'+this.sourceColumnName
    if(type === 'excel') {
      setTimeout(() => {
        this.gridApi.exportDataAsExcel(this.getParams());
      }, 1000);
    } else if(type === 'csv') {
      setTimeout(() => {
        this.gridApi.exportDataAsCsv( this.getParams());
      }, 1000);
    }
  }
  getParams() {
    this.sourceColumnName = this.commonService.sourceColumnName;
    let fileName: any;
    if(this.commonService && this.commonService.glreconName) {
      fileName = this.commonService.glreconName;
    } else {
      fileName = this.currentReconProcess.reconName+'_'+this.sourceColumnName;
    }
    return {
      onlySelected: false,
      fileName: fileName
    };
  }
  onCellClicked (event: CellClickedEvent): void{
    // console.log(event);
    if(event.colDef.headerName === 'Ops Remarks' || event.colDef.headerName === 'Recon Remarks') {
      if(event.value === null || event.value === '' || event.value === undefined) {
        event.colDef.editable = true;
      } else {
        event.colDef.editable = false;
      }
    }
  }
  clickedAllRecords(event: any) {
    console.log(event);
    if(event.checked === true) {
      let c: any = 'checked';
      this.commonService.allrecordsClicked = c;
    } else if(event.checked === false) {
      let uc: any = 'uncheck';
      this.commonService.allrecordsClicked = uc;
    }
  }
  // onCellClickedForGlview(event: CellClickedEvent): any {
  //   console.log('event for the gl view', event);
  //   if(event.colDef.headerName === 'Count') {
  //     this.cs.glClickedEventData(event.data);
  //   } else {
  //     return false;
  //   }
  // }
  onCellValueChanged(event: any) {
    console.log(event);
    this.remarksData.push(event.data);
    console.log(this.remarksData)
  }
  saveRemarks() {
    let params = {};
    params = {
      reconId: this.currentReconProcess.reconId,
      records: JSON.stringify(this.remarksData),
      operations: this.sourceColumnName,
      stmtdate: ''
    }
    this.baseService.doRequest(`/api/recons/updateData`, 'post', params).subscribe((result: any) => {
      if(result.status === true) {
        this.toast.sToast('success', result.message);
        this.remarksData = [];
      } else {
        this.toast.sToast('error', result.message);
        this.remarksData = [];
      }
    });
  }

  /* For Report Builder */
  onColumnRowGroupChanged(event: any) {
    this.rowGroup = event && event.column && event.column.colId;
    console.log(event);
  }
  saveForReportBuilder() {
    this.allColumns = this.gridColumnApi.getAllColumns();
    let c: any;
    let p: any = [];
    let visible: boolean = false
    console.log(this.allColumns)
    this.allColumns.forEach((ele: any) => {
      if(ele.visible === true) {
        visible = false;
      } else {
        visible = true
      }
      c = Object.assign({}, {headerName: ele.colId, hide: visible});
      p.push(c)
    });
    this.gridOptions.api.forEachNodeAfterFilterAndSort((rowNode: any, index: number) => {
      console.log('node ' + rowNode.data.athlete + ' passes the filter and is in this order');
    });
    let params: any = {};
    params['table1'] = {
      'groupBy': {
        colId: this.rowGroup
      },
      'records': {
        rows: this.selectedRow
      },
      sheetWise: true
    }
    this.baseService.doRequest('', 'post', params).subscribe((result: any) => {
      console.log(result);
    })
  }
  saveGridTableSettings(): void {
    // this.allColumns = this.gridColumnApi.getAllColumns();
    this.allColumns = this.gridColumnApi.getColumnState();
    let c: any;
    let p: any = [];
    let visible: boolean = false
    this.allColumns.map((ele: any) => {
      c = Object.assign({}, {headerName: ele.colId, hide: ele.hide});
      p.push(c)
    });
    let params: any = {};
    if(this.gridTableSetting && this.gridTableSetting._id) {
      params = {
        "tableId": 'aggrid',
        "columnRepr": JSON.stringify(p),
        "refreshInterval": 0,
        //"userId": this.currentUser.email,
        "settings": "",
        "reconId": this.currentReconProcess.reconId,
        "function": this.commonService.funtionName,
        "source": this.sourceColumnName ? this.sourceColumnName : 'All',
        "_id": this.gridTableSetting._id,
        "c": this.gridTableSetting.c,
        "u": this.gridTableSetting.u,
      }
    } else {
      params = {
        "tableId": 'aggrid',
        "columnRepr": JSON.stringify(p),
        "refreshInterval": 0,
        //"userId": this.currentUser.email,
        "settings": "",
        "reconId": this.currentReconProcess.reconId,
        "function": this.commonService.funtionName,
        "source": this.sourceColumnName ? this.sourceColumnName : 'All',
      }
    }
    let method = this.gridTableSetting && this.gridTableSetting._id ? 'put' : 'post'; 
    const url = this.gridTableSetting && this.gridTableSetting._id ? `/api/aggridsettings/` : `/api/aggridsettings/`;
    this.baseService.doRequest(url, method, params).subscribe((result: any) => {
      if(result) {
        if (method === 'post') {
          this.toast.sToast('success', 'Successfully saved table');
          this.getAggridTableSetting();
        } else {
          this.toast.sToast('success', 'Successfully updated');
          this.getAggridTableSetting();
        }
      } else {
        this.toast.sToast('error', result);
      }
    })
  }

  getAggridTableSetting() {
    console.log("this is form ag grid table");
    let params = {
      'query': { reconId: this.currentReconProcess.reconId }
    }
    const q = JSON.stringify(params);
    const limit = 1000;
    this.baseService.doRequest(`/api/aggridsettings/`, 'get', null, {q, limit}).subscribe((result: any) => {
      console.log("get method from grid table", result)
      if(result.data && result.data.length > 0) {  
        this.gridTable = result.data;
        console.log('this from grid table');
        // let data = JSON.parse(this.gridTable);
        this.gridTableSetting = this.gridTable[this.gridTable.length - 1];
      }
    })
  }
}
